module.exports = __webpack_public_path__ + "img/banner-line_big.e3e49a4e.png";